import LegalContentRenderer from '../components/LegalContentRenderer';
import { shippingContent } from '../mock/legalContent';

const ShippingReturn = () => <LegalContentRenderer content={shippingContent} />;

export default ShippingReturn;
